"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleAvailability = void 0;
const core_1 = require("@angular/core");
let VehicleAvailability = class VehicleAvailability {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleAvailability.prototype, "vehicle", void 0);
VehicleAvailability = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-availability',
        template: `
    <ng-container [ngSwitch]="vehicle.vehicleData.availability?.code">
      <tag *ngSwitchCase="'S'" text="Verkauft" color="red">
        <svg class="ab-icon icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content">
          <span *ngIf="vehicle.vehicleData.availability?.sellData.customer"><b>Kunde: </b>
            {{ vehicle.vehicleData.availability?.sellData?.customer }} <br>
          </span>
          <span *ngIf="vehicle.vehicleData.availability?.sellData.customerId"><b>Kunde: </b>
            <customer-name [customerId]="vehicle.vehicleData.availability?.sellData.customerId" ></customer-name> <br>
          </span>
          <span><b>Verkäufer:</b> <user-name [userId]="vehicle.vehicleData.availability?.sellData?.seller"></user-name></span> <br>
          <span><b>Geplante Auslieferung:</b> {{ vehicle.vehicleData.availability?.sellData?.plannedHandover | date }}</span> <br>
          <span><b>Datum Kaufvertrag:</b> {{ vehicle.vehicleData.availability?.sellData?.contractDate | date }}</span>
        </div>
      </tag>

      <tag *ngSwitchCase="'R'" text="Reserviert" color="orange">
        <svg class="ab-icon icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content">
          <span *ngIf="vehicle.vehicleData.availability?.reservationData?.customer"><b>Kunde: </b>
            {{ vehicle.vehicleData.availability?.reservationData?.customer }} <br>
          </span>
          <span *ngIf="vehicle.vehicleData.availability?.reservationData?.customerId"><b>Kunde: </b>
            <customer-name [customerId]="vehicle.vehicleData.availability?.reservationData?.customerId" ></customer-name> <br>
          </span>
          <span><b>Verkäufer:</b> <user-name [userId]="vehicle.vehicleData.availability?.reservationData?.seller"></user-name></span> <br>

          <span><b>Enddatum:</b> {{ vehicle.vehicleData.availability?.reservationData?.reservationDate  | date }}</span>
        </div>
      </tag>

      <tag *ngSwitchCase="'A'" text="Verfügbar" color="green"></tag>
    </ng-container>
  `,
    })
], VehicleAvailability);
exports.VehicleAvailability = VehicleAvailability;
